import { loadAppearance } from './appearance';

/** Builds ?theme=...&mode=...&accent=... from the current persisted appearance. */
export function buildThemeParams(): string {
  const { themeName, colorScheme, accentColor } = loadAppearance();
  const resolvedMode =
    colorScheme === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
      : (colorScheme ?? 'light');

  const p = new URLSearchParams();
  const theme = themeName === '__default__' ? '' : (themeName ?? '');
  if (theme) p.set('theme', theme);
  if (resolvedMode) p.set('mode', resolvedMode);
  if (accentColor) p.set('accent', accentColor);
  const s = p.toString();
  return s ? `&${s}` : '';
}
